import { ApiResult, request, safeRequest } from '@synergy/api';

import { FunctionalAsset } from '../../models/functional-asset';

export class FunctionalAssetApi {
    constructor(protected baseUrl: string) {}

    public cget = async (supplierId: number, params: { customerId: number }): Promise<ApiResult<FunctionalAsset[]>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/suppliers/${supplierId}/functional-assets`, { params }),
            response => response.data
        );
    };
}
